import { MarketPricePill } from '~/components/ui/MarketPricePill';
import type { Money, UnitCode } from '~/graphql/graphql';
import {
  formatPricedMarketMid,
  marketMidPriceIn,
  percentFromMarket,
} from '~/utils/marketMidPrice';
import type { Dimensions } from '~/utils/unitConversion';

type CartItemMarketPriceProps = {
  marketMid: Pick<Money, 'amount' | 'currency'> | null | undefined;
  displayUnit: UnitCode;
  standardUnit: UnitCode;
  dims: Dimensions;
  displayPricePerUnit: number | null;
  priceUnit: UnitCode;
  currency?: string;
};

export function CartItemMarketPrice({
  marketMid,
  displayUnit,
  standardUnit,
  dims,
  displayPricePerUnit,
  priceUnit,
  currency,
}: Readonly<CartItemMarketPriceProps>) {
  if (marketMid == null) return null;
  const market = marketMidPriceIn(
    marketMid.amount,
    displayUnit,
    standardUnit,
    dims
  );
  const percent =
    market.amount != null &&
    displayPricePerUnit != null &&
    market.unit === priceUnit &&
    marketMid.currency === currency
      ? percentFromMarket(displayPricePerUnit, market.amount)
      : null;

  const price = formatPricedMarketMid(market, marketMid.currency);
  if (price == null) return null;

  return (
    <div className="mt-1">
      <MarketPricePill price={price} percentFromMarket={percent} />
    </div>
  );
}
